

let baseUrl = "https://api.pidigihub.in";

// const hostname = window.location.hostname;

// if (hostname.includes("pidigihub.in")) {
//     baseUrl = "https://api.pidigihub.in";
// } else if (hostname.includes("pidigihublibrary.objectsquare.in")) {
//     baseUrl = "https://apipidigihub.objectsquare.in";
// } else {

//     baseUrl = "https://apipidigihub.objectsquare.in";
// }
export { baseUrl };
